import TableSearch from '@rio-cloud/rio-uikit/TableSearch';
import { debounce } from 'es-toolkit/compat';
import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { historyActions } from './redux/history.redux';

interface Props {
    onSearchChange: (searchValue?: string) => void;
}

const HistoryTableSearch = (props: Props) => {
    const { onSearchChange } = props;
    const [localSearch, setLocalSearch] = useState<string>();
    const intl = useIntl();

    const replaceSearch = useMemo<(search: string) => void>(
        () => debounce(search => onSearchChange(search), 500),
        [onSearchChange]
    );

    return (
        <TableSearch
            placeholder={intl.formatMessage({ id: 'intl-msg:marketplace.history.search.placeholder' })}
            value={localSearch}
            onChange={(text: string) => {
                setLocalSearch(text);
                replaceSearch(text);
            }}
        />
    );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    onSearchChange: (searchValue?: string) => dispatch(historyActions.setResourceSearch(searchValue)),
});

export const HistoryTableSearchContainer = connect(null, mapDispatchToProps)(HistoryTableSearch);
